import {Directive, Input, Output, EventEmitter, OnInit, ElementRef} from '@angular/core';
import {DecimalPipe} from '@angular/common';

@Directive({
    selector: '[duxIrbCurrencyFormatter]',
    host: {
        '[value]': 'duxIrbCurrencyFormatter',
        '(input)': 'format($event.target.value)'
    },
    standalone: false
})
export class IrbCurrencyFormatterDirective implements OnInit {

    @Input()
    duxIrbCurrencyFormatter: string;

    @Output()
    duxIrbCurrencyFormatterChange: EventEmitter<string> = new EventEmitter<string>();

    displaySymbol = '$';

    constructor(public el: ElementRef, public decP: DecimalPipe) {
        this.el.nativeElement.onkeypress = (evt: any) => {
            this.displaySymbol = this.el.nativeElement.defaultValue;
            if (evt.which === 45) {
                let curVal = this.el.nativeElement.value;
                curVal = curVal.replace(this.displaySymbol, '');
                if (curVal.length > 0) {
                    evt.preventDefault();
                }
            } else if (evt.which < 48 || evt.which > 57) {
                evt.preventDefault();
            }
        };
    }

    ngOnInit() {
        this.duxIrbCurrencyFormatter = this.duxIrbCurrencyFormatter || '';
        this.format(this.duxIrbCurrencyFormatter);
    }
    format(value: any) {
        if (value !== null && value !== '' && value !== '-' && value !== this.displaySymbol && value !== (this.displaySymbol + '(') && value !== this.displaySymbol) {
            const isValueNagitive = (value.indexOf('-') > -1 || value.indexOf('(') > -1) ? true : false;
            if (isValueNagitive) {
                value = value.replace('-', '');
            }
            value = value.replace(this.displaySymbol, '');
            value = value.replace('(', '');
            value = value.replace(')', '');
            value = value.replace(/,|_/g, '');
            this.el.nativeElement.rawData = Number(isValueNagitive ? value * -1 : value);
            value = this.decP.transform(value, '1.0-0');
            if (isValueNagitive === true) {
                value = '(' + value + ')';
                this.el.nativeElement.style.color = 'red';
            } else {
                this.el.nativeElement.style.color = '';
            }
            if (this.displaySymbol === '$') {
                this.duxIrbCurrencyFormatterChange.next(this.displaySymbol + value);
            } else {
                this.duxIrbCurrencyFormatterChange.next(value + this.displaySymbol );
            }
        } else {
            this.el.nativeElement.rawData = '';
            this.duxIrbCurrencyFormatterChange.next(value);
        }
    }
}
